import { FadeIn, Skeleton } from "@xola/ui-kit";
import React from "react";
import { useQuery } from "react-query";
import { XolaBotAssistType, XolaBotAssistTypeCopy } from "types";
import shallow from "zustand/shallow";
import { useSeller } from "../../../hooks/useAccount";
import { getXolaBotElasticsearchParams } from "../../../reports/XolaBotEarningsReport";
import { useXolaBotEarningsReportFilterStore } from "../../../stores/reports/xolabotEarningsReportFilterStore";
import { Currency } from "../../Common/Currency";

export const XolaBotEarningsReportSummary = () => {
    const seller = useSeller();

    const [from, to] = useXolaBotEarningsReportFilterStore((state) => [state.getFrom(), state.getTo()], shallow);
    const filters = useXolaBotEarningsReportFilterStore((state) => state.filters);

    const params = { seller, filters, from, to };
    const { data, isLoading } = useQuery(["xolaBotEarningsReport", params], async () => {
        return getXolaBotElasticsearchParams(params);
    });

    if (isLoading || !data) {
        return <XolaBotEarningsReportSkeleton />;
    }

    const { total, assistTypes }: { total: number; assistTypes: Array<{ type: XolaBotAssistType; total: number }> } =
        data;

    return (
        <FadeIn>
            <div className="w-full px-6 py-11">
                <div className="flex h-32 w-full flex-row justify-between space-x-3">
                    <div className="flex flex-col items-center justify-center space-y-2 rounded bg-green-lighter py-8 px-12">
                        <span className="font-bold">Total</span>
                        <div className="text-2xl font-bold">
                            <Currency.Split currency={seller.currency}>{total}</Currency.Split>
                        </div>
                    </div>
                    <div className="flex w-full flex-row justify-start space-x-28 rounded border border-gray-light py-9 px-8">
                        {assistTypes.map((assistType) => (
                            <XolaBotEarningsReportType
                                key={assistType.type}
                                type={assistType.type}
                                total={assistType.total}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </FadeIn>
    );
};

const XolaBotEarningsReportSkeleton = () => (
    <div className="w-full px-6 py-10">
        <div className="flex h-32 w-full flex-row justify-between space-x-2">
            <div className="w-44">
                <Skeleton height={128} />
            </div>
            <div className="w-full">
                <Skeleton height={128} />
            </div>
        </div>
    </div>
);

const XolaBotEarningsReportType = ({ type, total }: { type: XolaBotAssistType; total: number }) => {
    const seller = useSeller();

    return (
        <div className="flex flex-col items-center space-y-2">
            <div className="flex flex-row items-center space-x-1">
                <div className="text">{XolaBotAssistTypeCopy[type]}</div>
            </div>

            <div className="text-lg font-bold">
                <Currency.Split currency={seller.currency}>{total}</Currency.Split>
            </div>
        </div>
    );
};
